var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 1.625V7.3125C8.875 7.55859 9.06641 7.75 9.3125 7.75C9.53125 7.75 9.75 7.55859 9.75 7.3125V2.5C9.75 2.03516 10.1328 1.625 10.625 1.625C11.0898 1.625 11.5 2.03516 11.5 2.5V7.3125C11.5 7.55859 11.6914 7.75 11.9375 7.75C12.1562 7.75 12.375 7.55859 12.375 7.3125V4.25C12.375 3.78516 12.7578 3.375 13.25 3.375C13.7148 3.375 14.125 3.78516 14.125 4.25V9.9375C14.125 12.6172 11.9648 14.75 9.3125 14.75H8.76562C7.15234 14.75 5.56641 14.1484 4.39062 13L1.32812 10.0742C0.890625 9.66406 0.863281 8.98047 1.30078 8.54297C1.71094 8.10547 2.39453 8.07812 2.83203 8.48828L4.5 10.0742C4.5 10.0469 4.5 9.99219 4.5 9.9375V2.5C4.5 2.03516 4.88281 1.625 5.375 1.625C5.83984 1.625 6.25 2.03516 6.25 2.5V7.3125C6.25 7.55859 6.44141 7.75 6.6875 7.75C6.90625 7.75 7.125 7.55859 7.125 7.3125V1.625C7.125 1.16016 7.50781 0.75 8 0.75C8.46484 0.75 8.875 1.16016 8.875 1.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.ed04e466c9299a87cf59dfae5dd19b94.svg";
export { ForwardRef as ReactComponent };